import { useMutation, useQueryClient } from '@tanstack/vue-query'
import wAxios from '@/plugins/w/axios/models/axios'
import { MedirexPdf } from '@/plugins/refactor/classes/MedirexPdf'
import { useToast } from '@/plugins/w/toast/_composeables'
import { QUERY_KEY as SUMMARY_REQUESTS_QUERY_KEY } from '@/plugins/app@lz/request/_services/summary-requests.service'

/**
 * Mutation for printing unprinted requests
 * @returns
 */
export const usePrintUnprintedRequests = () => {
	const queryClient = useQueryClient()

	const { error: toastError, success } = useToast()

	return useMutation({
		mutationFn: async () => {
			const { contents, name } = await wAxios.post_auth_data(`v1/requests/print/unprinted`, {
				type: 'summary'
			})

			const medirexPdf = new MedirexPdf(contents, name)
			medirexPdf.open()
		},
		onError(error, _variables, _context) {
			queryClient.invalidateQueries({ queryKey: ['dashboard'] })
			toastError(error)
		},
		onSuccess(_data) {
			queryClient.invalidateQueries({ queryKey: ['dashboard'] })
			queryClient.invalidateQueries({ queryKey: [SUMMARY_REQUESTS_QUERY_KEY] })

			// success('OK')
		}
	})
}

/**
 * Mutation for printing or downloading request
 * @returns
 */
export const useDownloadPrintRequests = () => {
	const { error: toastError, success } = useToast()

	return useMutation({
		mutationFn: async (data: { requests: { id: number }[]; action: string; event?: any }) => {
			try {
				const { requests, action } = data

				const { contents, name } = await wAxios.post_auth_data(`v1/requests/print`, {
					type: 'blank',
					requests: requests
				})

				const medirexPdf = new MedirexPdf(contents, name)

				if (action === 'download') medirexPdf.download()
				else medirexPdf.open()
				data?.event.complete()
			} catch (error) {
				data?.event.complete()
				throw error
			}
		},
		onError(error, _variables, _context) {
			toastError(error)
		},
		onSuccess(_data) {
			// success('OK')
		}
	})
}

/**
 * Mutation data from Reqqest to result
 * @returns
 */
export const transformData = async data => {
	return {
		first_name: data.patient?.first_name ?? '',
		last_name: data.patient?.last_name ?? '',
		personal_id: data.patient?.personal_id ?? null,
		request_id: data.examination_request?.barcode ?? null,
		order_id: data?.order_id ?? null,
		creation_date: data.examination_request?.creation_time ?? null,
		state: data?.order_state ?? null,
		is_printed: data.order?.request?.printed ?? false,
		is_readed: false, // Manually set as per your requirement
		last_result_date: null, // Preset empty
		date_of_birth: (data.patient?.birth_date?.split('T')[0] ?? '') + ' 00:00:00',
		labs:
			data.order?.products?.map(product => ({
				id: product.product?.labs?.[0]?.id ?? '',
				external_id: product.product?.labs?.[0]?.external_id ?? '',
				name: product.product?.labs?.[0]?.name ?? '',
				requires_individual_request:
					product.product?.labs?.[0]?.requires_individual_request ?? false
			})) ?? [],
		id: data.order?.id ?? null,
		can_be_summary_printed: data.order?.request?.can_be_summary_printed ?? false,
		printed_at: data.order?.request?.printed_at ?? null,
		patient_id: data.patient?.id ?? null,
		moreLoad: false
	}
}

// /**
//  * Mutation for deleting requests
//  * @returns
//  */
// export const useDeleteSelectedRows = (callback = () => {}) => {
// 	const { t } = useI18n()
// 	const { error: toastError, success } = useToast()

// 	return useMutation({
// 		mutationFn: async (orders: [{ id: number }]) => {
// 			await wAxios.post_auth(`v1/orders`, {
// 				_method: 'DELETE',
// 				orders
// 			})
// 		},
// 		onError(error, _variables, _context) {
// 			toastError(error)
// 		},
// 		onSuccess(_data) {
// 			success(t('Žiadanky boli úspešne zmazané'))
// 			callback()
// 		}
// 	})
// }

export const usePrintDownloadSummaryRequests = () => {
	const queryClient = useQueryClient()

	const { error: toastError, success } = useToast()

	return useMutation({
		mutationFn: async (data: { requests: { id: number }[]; action: 'open' | 'download'; event?: any, type: 'single' | 'multiple' }) => {
			let contents = null
			let name = null

			if (data.type === 'single') {
				const response = await wAxios.get_auth_data(`v1/requests/summary/${data.requests[0].id}`)
				contents = response.contents
				name = response.name
			}
			else {
				const response = await wAxios.post_auth_data(`v1/requests/summary/print`, 
					{
						summaryRequests: data.requests,
						type: 'summary'
					}
				)
				contents = response.contents
				name = response.name
			}
			

			const medirexPdf = new MedirexPdf(contents, name)
			if (data.action === 'open') medirexPdf.open()
			else medirexPdf.download()
			data?.event.complete()
		},
		onError(error, _variables, _context) {
			queryClient.invalidateQueries({ queryKey: ['dashboard'] })
			toastError(error)
		},
		onSuccess(_data) {
			queryClient.invalidateQueries({ queryKey: ['dashboard'] })
			// success('OK')
		}
	})
}
